// 启用远程设置弹框

import React, { useState, useEffect } from "react";
import { Modal, message, Button, Input } from "antd";

import BoxServe from "../../../../ajax/api/index";
const { TextArea } = Input;
export default function RemoteSettingsModel(props) {

  const [loading, setLoading] = useState(false);

  const [ipv4, setIpv4] = useState("");

  const [port, setPort] = useState("80");

  const [url, setUrl] = useState("");

  // 关闭弹框
  const onCancel = () => {
    setUrl("");
    props.handleSettingsModelClose(false);
  };

  // 修改ipv4
  const handleChangeIpv4 = (e) => {
    console.log(e);
    setIpv4(e.target.value);
  };

  // 修改端口号
  const handlePort = (e) => {
    setPort(e.target.value);
  };

  // 跳转
  const handleJump = () => {
    if (url) {
      window.open(url);
    }
  };

  useEffect(() => {
    let ip = props?.item?.netAddr?.ipv4?.[0];
    if (ip) {
      let ipArr = ip?.split(".");
      ipArr[ipArr?.length - 1] = "1";
      setIpv4(ipArr.join("."));
    }
  }, [props]);

  // 提交
  const handleSubmit = async () => {
    const deviceId = props.item?.id;
    const params = {
      deviceId,
      routeIp: ipv4,
      routePort: port,
    };
    if (props.item.natType === "其他" || props.item.natType === "其它") {
      return message.warning("设备已开启防火墙，无法访问");
    }
    try {
      setLoading(true);
      const { code, msg, data } = await BoxServe.sendStartFrp(params).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        message.success(msg);
        setUrl(data);
        // setTimeout(() => {
        //   props.getBusinessList("business"); // 列表需要重置选中
        // }, 200);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
      console.log(error);
    }
  };
  let linkHtml;
  if (url) {
    linkHtml = (
      <div className="item">
        <span className="title">链接:</span>
        <span className="input">
          <label className="link" onClick={handleJump}>
            {url}
          </label>
        </span>
      </div>
    );
  }

  // 判断是否为“其它”
  let otherHtml = null;
  if (props.item.natType === "其他" || props.item.natType === "其它") {
    otherHtml = (
      <div className="item">
        <span className="title">提示:</span>
        <span className="input">
          <label className="other">设备已开启防火墙，无法访问</label>
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="business-switching pressure-measurement ">
        <Modal title="启用远程设置(5分钟后点击下方链接可访问)" width="800px" className="remote-settings-model" footer={null} open={props.open} onCancel={onCancel}>
          <div className="box">
            <div className="item">
              <span className="title">IPV4:</span>
              <span className="input">
                <Input placeholder="请输入IPV4" allowClear value={ipv4} onChange={handleChangeIpv4} />
              </span>
            </div>
            <div className="item">
              <span className="title">端口:</span>
              <span className="input">
                <Input placeholder="请输入端口号" allowClear value={port} onChange={handlePort} />
              </span>
            </div>
            {otherHtml}
            {linkHtml}
          </div>

          <div className="btns">
            <Button type="primary" className="box-btn" loading={loading} shape="round" size={"large"} onClick={handleSubmit}>
              确 定
            </Button>
          </div>
        </Modal>
      </div>
    </>
  );
}
